import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus } from '../../types/analytics';

export function trackShow(offerStatus: TAnalyticsOfferStatus) {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Show',
    label: 'deal_safe_rent_choose',
  });
}

export function trackClick(label: string, offerStatus: TAnalyticsOfferStatus) {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'Click',
    label,
  });
}
